<template>
  <div class="access-denied">
    <div class="icon">
      <feather type="lock"/>
    </div>
    <h4>{{ title }}</h4>
    <p class="text-muted">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'AiChatAccessDenied',
  props: {
    title: { type: String, default: 'У вас нет доступа к AI-чату' },
    message: { type: String, default: 'Обратитесь к администратору, чтобы получить право ai-chat.use.' },
  },
};
</script>

<style scoped lang="scss">
.access-denied {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 4rem 1rem;
  min-height: 50vh;

  .icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #f1f3f5;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    color: #868e96;
  }

  h4 { margin-bottom: .5rem; }
  p { max-width: 480px; }
}
</style>
